import RatingContainer from "../../Componant/BonusUI/Rating";

const Rating = () => {
  return (
    <div className="page-body">
      <RatingContainer />
    </div>
  );
};

export default Rating;
